import { Icon, tileIconName, type IconName } from '@gftg/ui';

/**
 * A home tile's glyph. The mapping from a stored `icon_key` to an icon is in the kit, because the
 * console draws the same rows on the screen where organizers add them.
 */
export function TileIcon({
  iconKey,
  size = 22,
  className,
  fallback = 'agenda',
}: {
  iconKey: string | null;
  size?: number;
  className?: string;
  fallback?: IconName;
}) {
  return <Icon name={tileIconName(iconKey, fallback)} size={size} className={className} />;
}
